import { getSchoolYearFromAssessmentCalendar } from './getSchoolYearFromAssessmentCalendar';
import { getSchoolYear } from '../components/Reports/util/validation';

export interface SchoolYearResult {
  startDate: string;
  endDate: string;
  schoolYear: number;
  source: 'assessment_calendar' | 'school_year_calendar' | 'validation_fallback';
}

export interface SchoolYearCalendar {
  startDate?: string;
  endDate?: string;
  schoolYear?: number;
}

export interface AssessmentCalendar {
  periods?: Array<{
    periodIdentifier: number;
    startDate: string;
    endDate: string;
  }>;
}

/**
 * Gets school year dates with fallback logic
 * @param assessmentCalendar - Assessment calendar from Redux state
 * @param schoolYearCalendar - School year calendar from Redux state
 * @returns School year information with source indicator
 */
export function getSchoolYearWithFallbacks(
  assessmentCalendar: AssessmentCalendar | null | undefined,
  schoolYearCalendar: SchoolYearCalendar | null | undefined
): SchoolYearResult {
  // First priority: Assessment calendar (period 0 start -> period 11 end)
  if (assessmentCalendar) {
    const schoolYearDates = getSchoolYearFromAssessmentCalendar(assessmentCalendar);
    if (schoolYearDates) {
      return {
        startDate: schoolYearDates.startDate,
        endDate: schoolYearDates.endDate,
        schoolYear: new Date(schoolYearDates.startDate).getFullYear(),
        source: 'assessment_calendar'
      };
    }
  }

  // Second priority: School year calendar from Redux state
  if (schoolYearCalendar?.startDate && schoolYearCalendar?.endDate) {
    return {
      startDate: schoolYearCalendar.startDate,
      endDate: schoolYearCalendar.endDate,
      schoolYear: schoolYearCalendar.schoolYear || new Date(schoolYearCalendar.startDate).getFullYear(),
      source: 'school_year_calendar'
    };
  }

  // Final fallback: getSchoolYear function
  const fallbackSchoolYear = getSchoolYear();
  return {
    startDate: new Date(fallbackSchoolYear.startDate).toISOString().split('T')[0],
    endDate: new Date(fallbackSchoolYear.endDate).toISOString().split('T')[0],
    schoolYear: new Date(fallbackSchoolYear.startDate).getFullYear(),
    source: 'validation_fallback'
  };
} 